module.exports = __webpack_public_path__ + "img/hub_spot.68bbd818.png";